"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _checkmarkGreen = _interopRequireDefault(require("../assets/images/checkmark-green.svg"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: 8px;\n  font-weight: 400;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  float: right;\n  background: ", ";\n  border-radius: 116px;\n  height: 28px;\n  width: 28px;\n  margin-top: -5px;\n  ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    font-size: 1.3rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 600;\n  font-size: 15px;\n  padding: 8px 0;\n  color: ", ";\n  ", "\n  line-height: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: 1px solid ", ";\n  border-top: ", ";\n  padding: 32px 24px;\n  margin-top: ", ";\n  z-index: ", ";\n  display: ", ";\n  cursor: ", ";\n  width: 100%;\n  line-height: 1.3;\n\n  @media print, screen and (max-width: ", "px) {\n    border-width: 1px;\n    margin-top: -2px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div(_templateObject(), _Constant.Color.LIGHT_GREY_BORDER_2, function (props) {
  return !props.isFirstStep ? 'none' : "1px solid ".concat(_Constant.Color.LIGHT_GREY_BORDER_2);
}, function (props) {
  return props.isFirstStep && !props.expanded ? '-2px' : '0';
}, function (props) {
  return props.expanded ? 9 : 0;
}, function (props) {
  return props.expanded ? 'inline-block' : 'block';
}, function (props) {
  return props.checked ? 'pointer' : 'inherit';
}, _Constant.Width.MD);

var Header = _styledComponents.default.div(_templateObject2(), _Constant.Color.BLACK_SOUL, function (props) {
  return props.expanded ? '' : 'cursor: pointer;';
});
/**
 * @todo This isn't centered vertically.
 */


var CheckBox = _styledComponents.default.span(_templateObject3(), function (props) {
  return props.checked || props.expanded ? 'transparent' : _Constant.Color.GREY_3;
}, function (props) {
  return props.checked && "background-image:  url(".concat(_checkmarkGreen.default, ");\n      background-repeat: no-repeat;\n      background-position: center center;\n      background-size: 28px;\n    ");
}, _Constant.Width.MD);

var Content = _styledComponents.default.div(_templateObject4(), _Constant.Color.DARK_GREY_2);

var StepAccordion = function StepAccordion(_ref) {
  var header = _ref.header,
      expanded = _ref.expanded,
      checked = _ref.checked,
      children = _ref.children,
      step = _ref.step,
      isFirstStep = _ref.isFirstStep,
      showStep = _ref.showStep,
      onClick = _ref.onClick,
      className = _ref.className;

  /**
   * Wraps the passed onClick to only click if the accordion section isn't expanded and calls both new and deprecated callbacks for
   * backward compatibility.
   */
  var handleClick = function handleClick() {
    if (expanded) return; // Don't call the onClick callbacks if the header is expanded.

    onClick(step);
    showStep(step); // This is deprecated, please only use onClick.
  };

  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className,
    expanded: expanded,
    checked: checked,
    isFirstStep: isFirstStep,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(Header, {
    expanded: expanded
  }, header, " ", /*#__PURE__*/_react.default.createElement(CheckBox, {
    expanded: expanded,
    checked: checked
  })), expanded && /*#__PURE__*/_react.default.createElement(Content, null, children));
};

StepAccordion.propTypes = {
  /** Text displayed in header of accordion */
  header: _propTypes.default.string,

  /** Should checkmark be checked in header? */
  checked: _propTypes.default.bool.isRequired,

  /** Should accordion be expanded or closed? */
  expanded: _propTypes.default.bool.isRequired,

  /** Component/HTML to be displayed in the collapsible content of the accordion */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]).isRequired,

  /**
   * Function handling the logic of expanding/collapsing accordion
   *
   * @deprecated In favor of onClick.
   */
  showStep: _propTypes.default.func,

  /** Callback for handling clicking the header.  Passes back the target accordion step. */
  onClick: _propTypes.default.func,

  /** String associated with this particular accordion */
  step: _propTypes.default.string.isRequired,

  /** Is this accordion the top-most accordion - If so, add more margin */
  isFirstStep: _propTypes.default.bool,

  /** Class name to allow extending styles via styled-components. */
  className: _propTypes.default.string
};
StepAccordion.defaultProps = {
  header: '',
  isFirstStep: false,
  showStep: function showStep() {},
  onClick: function onClick() {},
  className: ''
};
var _default = StepAccordion;
exports.default = _default;